import { setBaseUrl, setExtraHeaders, setRequestCredentials } from "@serophin/shared";

declare const __BUILD_ID__: string;

/**
 * Requests go to the same origin, `/api/...`: CloudFront routes them in production and Vite proxies them in development.
 * `x-app` and `x-app-version` tag each request for the per-version request counts (version = the build id, `dev` under Vite).
 */
export const connectApi = (): void => {
  setBaseUrl("");
  setRequestCredentials("same-origin");
  setExtraHeaders({ "x-app": "web", "x-app-version": typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev" });
};
